import localforage from "localforage";

export class LocalStorage {
    constructor() {}
    async clear() {
        try {
            await localforage.clear();
        } catch (err) {
            console.warn(err);
        }
    }
    async delete(key) {
        try {
            await localforage.removeItem(key);
        } catch (err) {
            console.warn(err);
        }
    }
    async set(key, value) {
        try {
            const serializedData = JSON.stringify(value);
            await localforage.setItem(key, serializedData);
        } catch (err) {
            console.warn(err);
        }
    }
    async get(key) {
        try {
            const serializedData = await localforage.getItem(key);
            if (!serializedData) {
                return undefined;
            }

            return JSON.parse(serializedData);
        } catch (err) {
            return undefined;
        }
    }
}

export default new LocalStorage();
